import { Buffer } from "buffer";
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'whatwg-fetch';
import 'intersection-observer';
import UnsupportedBrowserAlert from './libs/UnsupportedBrowserMessage ';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';

import App from './App';
import reportWebVitals from './reportWebVitals';
import setupAxiosInterceptors from './libs/setupAxiosInterceptors';

import './index.css';
import './styles/designSystem.scss';

window.Buffer = Buffer;

// Register the global axios response interceptor before any request fires.
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
   
    <UnsupportedBrowserAlert/>

      <App />

  </Provider>

);


reportWebVitals();
